module.exports = __webpack_public_path__ + "assets/slike/granata.1c4cd671cc4d0e39ae2df33baa993fed.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/slike/granata.gif
// module id = 33
// module chunks = 0